'use strict';

// imports
//import 'babel-polyfill'
import {TreeList} from 'xm-react-treeview-mui'
//https://github.com/callemall/material-ui/issues/4670
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
injectTapEventPlugin();

import LoginForm from './LoginForm';
import SelectField from 'material-ui/SelectField';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import RaisedButton from 'material-ui/RaisedButton';
import AutoComplete from 'material-ui/AutoComplete';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import ActionAndroid from 'material-ui/svg-icons/action/android';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import CircularProgress from 'material-ui/CircularProgress';
import EmbeddedDossier from './EmbeddedDossier';
import TableauNav from './TableauNav';
import TableauEmbedded from './TableauEmbedded';
import Popover from 'material-ui/Popover/Popover';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory } from 'react-router';

import Container from 'muicss/lib/react/container';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';

import IconButton from 'material-ui/IconButton';
import PicAsPdf from 'material-ui/svg-icons/image/picture-as-pdf';
//import 'babel-polyfill';

// tag::vars[]
const React = require('react');
const ReactDOM = require('react-dom');
const client = require('./client');
const embeddedDossier = require('./EmbeddedDossier');
const tableauNav = require('./TableauNav');
const tableauEmbedded = require('./TableauEmbedded');
const loginForm = require('./LoginForm');




const folderInfo ='folder/children'
const reportInfo ='reports'
const sessionData ='sessiondata'
const recentReportsInfo = 'recent_reports'
const topReportsInfo = 'top_reports'
const staticContentInfo = 'api/staticContents/search/findMostRecentPerType'
	
const colorAccent = '#18202c'; // Blue: #0075A1 Navy Blue: #18202c
const colorHR = '#f28220'; // Green: #79B843 Orange: #f28220
const colorGray = '#e1e2e5';
const colorBlack = '#595959';

const menuProps = {	
		  autoWidth: true,
		  maxHeight: '300px',
		  style: {width: '500px', overflowX: 'auto'},
		  desktop: true,
		  disableAutoFocus: true,
		  listStyle: {overflowX: 'auto'}
		};

const ddmenuProps2 = {
			autoWidth: true
		};

const ddmenuProps = {
			autoWidth : true,
			menuStyle : {	
					  autoWidth: true,
					  maxHeight: 300,
					  width: 467,
					  desktop: true,
					  disableAutoFocus: true
					}
		};

const dataSourceConfig = {
		  text: 'Name',
		  value: 'GUID',
		};

const muiTheme = getMuiTheme({
    	fontFamily: "'Arial', sans-serif",
    	palette: {
    	    primary1Color: colorAccent,
    	    accent1Color: colorAccent
    	}
	});


const toolBarStyle = {
		backgroundColor: 'rgb(251, 250, 247, .1)',
		width: '100%'
	};

const filterToolBarStyle = {
		backgroundColor: 'white',
		width: '100%'
	};

const sbTextBarStyle = {
		width: '280px',
		marginLeft: '15px',
		paddingLeft: '10px',
		backgroundColor: 'white',
		border: '2px solid #e1e2e5'
	};

const sbTextBarStyleHidden = {
		width: '280px',
		marginLeft: '15px',
		paddingLeft: '10px',
		backgroundColor: 'rgb(251, 250, 247, .1)',
		border: '2px solid rgb(251, 250, 247, .1)'
	};

const ebTextBarStyle = {
		width: '120px',
		marginLeft: '10px',
		backgroundColor: 'rgb(251, 250, 247)',
		height: '50px'
	};

const ebTextBarStyleHidden = {
		width: '120px',
		marginLeft: '10px',
		backgroundColor: 'rgb(251, 250, 247, .1)'
	};


const progressStyle = {
		top: '50%',
		left: '60%',
		position: 'absolute'
	};

const styleHRGray = {
		backgroundColor: colorGray,
		marginTop:'10px',
		marginBottom:'10px',
		size: '2px'
}

var styleHRGreen = {
		backgroundColor: colorHR,
		marginTop:'3px',
		marginBottom:'10px',
		size: '2px'
}

const backgroundStyleEmbedded = {
	    backgroundImage: 'url(./img/banner.png)',
	    backgroundSize: 'cover'
};

// end::vars[]

// tag::app[]
class App extends React.Component {

	constructor(props) {
		super(props);
		if(localStorage.getItem('user') == null){
				window.location = '#/Login';
		}
		this.state = {staticContents: [], projects: [], reportData: [], reportNames: [], recentReports: [], topReports: [],
					  selectedProject: "", selectedReport: "", selectedProjectGUID: "", createSelectedProject: "", createSelectedProjectGUID: "", 
					  createRadioOption: "", serverData: [], errorState: false, userSSO: "John", dossierFilter: {}, selectedDossierFilter:"",
					  dossierFilter2: {}, selectedDossierFilter2:"", dossierValues: [], dossierValues2: [], dossierWidth:"95px", dossierWidth2:"170px",
						  embeddedState: "TableauEmbedded", embeddedEnableToolBar: false, tableauToken: "", tableauUser: "", tableauUserLocation: "East Coast Oceana Disposal S.E", tableauRole: "", tableauImg: "" };
		
		this.loadProjectsFromServer =  this.loadProjectsFromServer.bind(this);
		this.handleProjectSelection =  this.handleProjectSelection.bind(this);
		this.handleCreateProjectSelection =  this.handleCreateProjectSelection.bind(this);
		this.handleCreateRadioButton =  this.handleCreateRadioButton.bind(this);
		this.handleReportSelection =  this.handleReportSelection.bind(this);
		this.handleExecute =  this.handleExecute.bind(this);
		this.readCookie = this.readCookie.bind(this);
		this.handleDossierFilterSelection = this.handleDossierFilterSelection.bind(this);
		this.handleDossierFilterSelection2 = this.handleDossierFilterSelection2.bind(this);
		this.handleDossierLoadFilters = this.handleDossierLoadFilters.bind(this);
		this.navBlock = {};
		this.leftNavBar = {};
		this.searchBlock = {};
		this.mDossierFilterSelector ={};
		this.mDossierFilterSelector2 ={};
		this.embeddedDossier = {};
		this.mTableauEmbedded = {};
		this.mTableauNav = {};
	}
	
	changeFullState(EmbeddedState, isEnableToolBar) {
		this.setState({
			embeddedState: EmbeddedState,
			embeddedEnableToolBar: isEnableToolBar
		})
	}
	
	handleDossierLoadFilters(filters){
		var lFilter = filters[0];
		var ldossierValues = [];
		var ldossierValues2 = [];

		filters[0].filterDetail.items.forEach(function (element, elementindex){
				if(element.selected){
					ldossierValues.push(element.name)
				}
		});

		filters[1].filterDetail.items.forEach(function (element, elementindex){
			if(element.selected){
				ldossierValues2.push(element.name)
			}
		});
		var lTotalLenght = ldossierValues.reduce(function (accumulator, currentValue) {
			return accumulator + currentValue.length;
		}, 0);
		lTotalLenght = lTotalLenght==0?92:46+lTotalLenght*46/4;
		
		var lTotalLenght2 = ldossierValues2.reduce(function (accumulator, currentValue) {
			return accumulator + currentValue.length;
		}, 0);
		lTotalLenght2 = lTotalLenght2==0?92:46+lTotalLenght2*33/4;

		this.setState({
			dossierFilter: filters[0],
			dossierFilter2: filters[1],
			dossierValues: ldossierValues,
			dossierValues2: ldossierValues2,
			dossierWidth: lTotalLenght.toString()+"px",
			dossierWidth2: lTotalLenght2.toString()+"px"
		});
	}
	
	handleDossierFilterSelection(e, index, selection){
		var lSelection= {
				value: selection,
				key: this.state.dossierFilter.filterKey
		}
		var lTotalLenght = selection.reduce(function (accumulator, currentValue) {
			return accumulator + currentValue.length;
		}, 0);
		lTotalLenght = lTotalLenght==0?92:46+lTotalLenght*46/4;
		this.embeddedDossier.changeFilter(lSelection);
		this.setState({
			dossierValues: selection,
			dossierWidth: lTotalLenght.toString()+"px"
		});
	}
	
	handleDossierFilterSelection2(e, index, selection){
		var lSelection= {
				value: selection,
				key: this.state.dossierFilter2.filterKey
		}
		var lTotalLenght = selection.reduce(function (accumulator, currentValue) {
			return accumulator + currentValue.length;
		}, 0);
		lTotalLenght = lTotalLenght==0?92:46+lTotalLenght*35/4;
		this.embeddedDossier.changeFilter(lSelection);
		this.setState({
			dossierValues2: selection,
			dossierWidth2: lTotalLenght.toString()+"px"
		});
	}
	
	readCookie(name, list, separator){
	   var nameEQ = name + "=";
	    var ca = list.split(separator);
	    for(var i=0;i < ca.length;i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1,c.length);
	        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	    }
	    return null;
	}

	componentDidMount() {
		//this.loadProjectsFromServer();
		
		client({method: 'GET', path: staticContentInfo}).done(response => {
			this.setState({staticContents: response.entity._embedded.staticContents});
		});
		
		client({method: 'GET', path: 'serverdata'}).done(response => {
			var lServerData = response.entity;
			this.setState({serverData: lServerData});
			var lSSOToken = this.readCookie(lServerData.cookiename, document.cookie, ';');
			var lParams = {};
			lParams.user = localStorage.getItem('user');
			lParams.pwd = localStorage.getItem('pwd');
			
			client({method: 'GET',  path: 'tableautoken', params: lParams}).done(response => {
				var lTabToken =  response.entity.tabtoken,
				lRole =  response.entity.role,
				lImg =  response.entity.img,
				lFullUser = response.entity.fullname;
				if (lTabToken == '') {
					lTabToken = "John"
				}
				if(lTabToken == "-1"){
					localStorage.clear();
					window.location = "#/Login";
				}
				this.setState({
						tableauToken: lTabToken, 
						tableauRole: lRole,
						tableauImg: lImg,
						tableauUser: lFullUser
					
				});
			});
			/*
			client({method: 'GET',  path: 'ssodata', params: lParams}).done(response => {
				var lUserID =  this.readCookie('id', response.entity.user, ',');
				if (lUserID == '') {
					lUserID = "John"
				}
				
				var lParams = {};
				this.setState({userSSO: lUserID});
		        lParams.user  = lUserID;
				lParams.limit = "5";
				
				client({method: 'GET', path: recentReportsInfo, params: lParams}).done(response => {
					this.setState({recentReports: response.entity});
				});

				client({method: 'GET', path: topReportsInfo, params: lParams}).done(response => {
					this.setState({topReports: response.entity});
				});
				this.leftNavBar.triggerInitialLoad && this.leftNavBar.triggerInitialLoad();
				this.leftNavBar.triggerInitialLoad && this.loadProjectsFromServer();
			});
			*/
			
		});
		
	}
	
	handleExecute() {
		var lServerURL = this.state.serverData.webserver;
		var lIServer = this.state.serverData.server;
		var lProjectName = encodeURIComponent(this.state.selectedProject);
		var lReportGUID = this.state.selectedReport.GUID;
		var lParams = {};
		var lResult = []
		lParams.user = this.state.userSSO;
		lParams.project = this.state.selectedProjectGUID;

		client({method: 'GET', path: sessionData, params: lParams}).done(sessionInformation => {
			var lSessionInfo = encodeURIComponent(sessionInformation.entity.sessionInfo);
			switch(this.state.selectedReport.ObjectType){
				case '3':
					window.open(lServerURL+"?server="+lIServer+"&project="+lProjectName+"&evt=4001&Main.aspx.4001&reportViewMode=1&reportID="+lReportGUID+"&usrSmgr="+lSessionInfo,"_self")
					break
				case '55':
					if(this.state.selectedReport.ObjectView == '8192') {
						window.open(lServerURL+"?evt=3140&Main.aspx.3140&documentID="+lReportGUID+"&server="+lIServer+"&project="+lProjectName+"&usrSmgr="+lSessionInfo,"_self")
					} else{
						window.open(lServerURL+"?server="+lIServer+"&project="+lProjectName+"&evt=2048001&Main.aspx.2048001&currentViewMedia=2&documentID="+lReportGUID+"&usrSmgr="+lSessionInfo,"_self")
					}
					break
				case '64':
					window.open(lServerURL+"?server="+lIServer+"&project=MicroStrategy+Tutorial&evt=4001&Main.aspx.4001&reportViewMode=1&reportID="+lReportGUID+"&usrSmgr="+lSessionInfo,"_self")
					break;
				default:
					break;
				}
		});
	}
	
	handleReportSelection(value) {
		this.setState({
			selectedReport: value
		});
	}
	
	handleProjectSelection(event, index, value) {
		var lParams = {};
		var lResult = []
		lParams.user = this.state.userSSO;
		lParams.pid = this.mSearchProjectSelector.props.children[index].props.projectGUID;
		client({method: 'GET', path: reportInfo, params: lParams}).done(reportList => {
			for (var prop in reportList.entity) {
			    if (reportList.entity.hasOwnProperty(prop)) {
			    	lResult.push(reportList.entity[prop])
			    }
			}
			this.searchBlock.setState({
				curtain: false
			});
			this.setState({
				reportData: reportList.entity,
				reportNames: lResult,
				selectedProject: value,
				selectedProjectGUID: lParams.pid
			});
		}, response => {
			this.searchBlock.setState({
				curtain: false
			});			
			this.setState({
				reportData: [],
				reportNames: ["Error retrieving report data"],
				selectedProject: "",
				errorState: true
			});
		});
		
		
		this.searchBlock.setState({
			curtain: true
		});
		this.setState({
			selectedProject: "",
			selectedReport: "",
			errorState: false
		});
	}
	
	handleCreateProjectSelection(event, index, value) {
		var lPid = this.mSearchProjectSelector.props.children[index].props.projectGUID;
		this.setState({
			createSelectedProject: value,
			createSelectedProjectGUID: lPid
		});
	}
	
	handleCreateRadioButton(handler, value) {
		this.setState({
			createRadioOption: value
		});
	}
	
	loadProjectsFromServer() {
		var lParams = {};
		var lResult = [];
		
		lParams.user = this.state.userSSO;
		client({method: 'GET', path: folderInfo, params: lParams}).done(projectList => {
			for (var prop in projectList.entity) {
			    if (projectList.entity.hasOwnProperty(prop)) {
			    	lResult.push(
		        		{
		        			title: projectList.entity[prop].Name,
		        		    projectGUID: projectList.entity[prop].GUID,
		        		} 	
			        )
			    }
			}
			this.navBlock.setState({
				curtain: false
			});
			this.setState({
				projects: lResult,
				projectsCurtain: false
			});
		});
		this.navBlock.setState({
			curtain: true
		});
	}

	render() {
		var app = this,
			lDossierFilterItems = (this.state.dossierFilter.filterDetail && this.state.dossierFilter.filterDetail.items?  this.state.dossierFilter.filterDetail.items : []),
			lDossierFilterItems2 = (this.state.dossierFilter2.filterDetail && this.state.dossierFilter2.filterDetail.items?  this.state.dossierFilter2.filterDetail.items : [])
			
		var imageHeaderHeight = parseInt(window.innerWidth/8.5);
		
		muiTheme.menu.containerBackgroundColor = '#42444c';
		return(
				<MuiThemeProvider muiTheme={muiTheme}>
				  <div style={{minWidth: '1024px'}}>
				  <Container fluid={true}>
				    <Row>
				      <Col style={{padding: '0px 0px 0px 0px'}} xs="12" md="12">
				      	
				      	<TableauTopBar container={this} navBar={this.mTableauNav} fulluser={this.state.tableauUser} userlocation={this.state.tableauUserLocation}/>
			      		<TableauNav ref={(c) => this.mTableauNav = c} app={this} fulluser={this.state.tableauUser} role={this.state.tableauRole} img={this.state.tableauImg}></TableauNav>
				      	{this.state.tableauToken != ""?
					      	(<PortalBlock  isTableau={true} title={''} image_name={'reports.png'} last_updated={true} displayHeader={false}>					        	
					      		<TableauEmbedded ref={(c) => this.mTableauEmbedded = c} app={this}></TableauEmbedded>
				      		</PortalBlock>)
				      		:
				      		(<div></div>)
				      	}
				      </Col>
				    </Row>
				  </Container>
				  </div>
				</MuiThemeProvider>
			)
	}
}
// end::app[]

//tag::top_bar[]
class TopBar extends React.Component{
	
	constructor(props) {
		super(props);
	}
	
	render() {
		var image_source = './img/Logo.png'
		
		var styleLogo = {
				  float: 'left',
				  margin: '5px 15px',
				  color: colorAccent
			}
		var styleWelcome = {
				  float: 'right',
				  margin: '10px 10px 0px 0px',
				  color: colorHR
			}
		
		return (
			<div style={{backgroundColor: colorAccent, height: '40px', borderBottom: '2px solid #f28220', marginBottom: '15px'}}>
  				<span style={styleLogo}><a href="."><img src={image_source} height="30px" /></a></span>
  				<span style={styleWelcome}>Welcome, {this.props.container.state.userSSO}</span>
			</div>
		)
	}
}
// end::top_bar[]

//tag::top_bar[]
class TableauTopBar extends React.Component{
	
	constructor(props) {
		super(props);
		this.app = this.props.container;
		this.logout = this.logout.bind(this);
		this.exportPDF = this.exportPDF.bind(this);
		this.exportXLS = this.exportXLS.bind(this);
		this.changeFilter = this.changeFilter.bind(this);
		this.handleRequestClose = this.handleRequestClose.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.state = {
				itemValue: 0
		    };
	}
	
	changeFilter(e, index, selection){
		this.setState({itemValue: e});
		this.props.navBar.setState({dossierInstance:index});
		this.props.container.mTableauEmbedded.changeViz(index);
	}
	
	logout () {
		localStorage.clear();
		window.location = "#/Login";
	}
	
	exportPDF () {
		this.app.mTableauEmbedded.exportPDF();
	    this.setState({
		      open: false,
		    });
	}
	
	exportXLS () {
		this.app.mTableauEmbedded.exportXLS();
	    this.setState({
		      open: false,
		    });
	}
	
	handleClick(event) {
	    event.preventDefault();

	    this.setState({
	      open: true,
	      anchorEl: event.currentTarget
	    });
	}
	
	handleRequestClose() {
	    this.setState({
	      open: false,
	    });
	}
	
	render() {
		

		var styleWelcome = {
				  color: 'white',
				  marginTop: '8px',
				  display: 'table-cell',
				  verticalAlign: 'middle',
				  width: '70px'
			}
		
		var styleTitle = {
				  color: 'white',
				  marginTop: '8px',
				  display: 'table-cell',
				  verticalAlign: 'middle',
				  fontSize: '19px'
			}
		
		
		var styleVendor = {
				  color: 'white',
				  marginTop: '8px',
				  display: 'table-cell',
				  verticalAlign: 'middle',
				  width: '80px'
			}
		
		var styleVendorName = {
				  color: '#00FFCB',
				  marginTop: '8px',
				  marginRight: '30px',
				  display: 'table-cell',
				  verticalAlign: 'middle',
				  cursor: 'pointer'
			}
		
		var styleToolBar = {
				  float: 'left',
				  color: 'white',
				  float: 'left',
				  width: '70%',
				  display: 'table',
				  marginLeft: '20px'
			}
		
		var styleToolBar2 = {
				  float: 'right',
				  color: 'white',
				  width: '270px',
				  display: 'table',
				  height: '58px'	
			}
		
		
		return (
			<div style={{backgroundColor: '#121047', height: '55px', fontSize: '17px',  borderBottom: '4px solid #00ffcb'}}>
				<span className="toolBar" style={styleToolBar}>
					<span style={{height: '58px', display: 'table-cell', verticalAlign: 'middle'}}>
						<img src={"./img/xeomatrix_name.png"} height= "22px" style={{textAlign: "center", margin: "auto", display: "initial"}} />
					</span>
					<span className="topButtons" style={{color:this.state.itemValue==0?'#00FFCB':'white'}} onClick={this.changeFilter.bind(this, 0, "Sales Funnel")}>Sales Funnel</span>
					<span className="topButtons" style={{width: '320px', color:this.state.itemValue==1?'#00FFCB':'white'}} onClick={this.changeFilter.bind(this, 1, "Location Performance")}>Location Performance</span>
					<span className="topButtons" style={{color:this.state.itemValue==2?'#00FFCB':'white'}} onClick={this.changeFilter.bind(this, 2, "Opportunity Detail")}>Opportunity Detail</span>
	  			</span>
	  			<span className="toolBar2" style={styleToolBar2}>
	  				<span style={styleVendor} >Welcome: </span>
	  				<span onClick={this.logout} style={styleVendorName} >{this.props.fulluser} </span>
				    <FlatButton
						hoverColor="#121047"
						backgroundColor="#121047"
						labelStyle={{color: "white"}}
						labelPosition="before"		
				      	label=""
				      	icon={<img src={"./img/hamburgermenu.png"} height= "16px" style={{textAlign: "center"}} />}
				      	style={{marginTop: '7px', marginRight: '2px', width: '30px', minWidth: '20px'}}
				      	onClick={this.handleClick}
				     />
			      	<Popover className ="custom-selectfield" 
				      	anchorOrigin={{ horizontal:"middle", vertical:"bottom"}}
		  				targetOrigin={{ horizontal:"right", vertical:"top"}}
				      	anchorEl={this.state.anchorEl}
			      		open={this.state.open}
			      		onRequestClose={this.handleRequestClose}
	  				>
				      	<Menu>
				      		<MenuItem onClick={this.exportPDF} value={0} key={0} style={{color: '#121047', fontSize:'15px', backgroundColor:this.state.itemValue==0?'#c0f6ef':'#c0f6ef'}} primaryText={'Export PDF'} />
							<MenuItem onClick={this.exportXLS} value={1} key={1} style={{color: '#121047', fontSize:'15px', backgroundColor:this.state.itemValue==1?'#c0f6ef':'#c0f6ef'}} primaryText={'Export XLS'} />
				      	</Menu>
			      	</Popover>	
	  			</span>
	  		</div>
		)
	}
}
// end::top_bar[]

			
			
//tag::report_link[]
class ReportLink extends React.Component{
	constructor(props) {
		super(props);
		this.state = {curtain: false};
		this.container = props.container;
	}
	
	render() {
		var report_type = this.props.report_type
		var report_id = this.props.report_id
		var report_name = this.props.report_name
		var project_name = this.props.project_name
		var project_name_url = encodeURIComponent(this.props.project_name)
		var lIServerName = this.props.iserver
		var lServerURL = this.props.url
		
		var link = ''
			
		switch(report_type){
			case 'Grid':
				link = lServerURL+"?server="+lIServerName+"&project="+project_name_url+"&evt=4001&Main.aspx.4001&reportViewMode=1&reportID="+report_id
				break
			case 'Dashboard':
				link = lServerURL+"?evt=3140&Main.aspx.3140&documentID="+report_id+"&server="+lIServerName+"&project="+project_name_url
				break
			case 'Document':
				link = lServerURL+"?server="+lIServerName+"&project="+project_name_url+"&evt=2048001&Main.aspx.2048001&currentViewMedia=2&documentID="+report_id
				break
		}
			
		return (				
		  <div style={{marginBottom: '10px'}}>
	  		<a href={link}><span style={{color:colorAccent}}>{report_name}</span></a>
	  		<br />
	  		<span style={{color:colorBlack,fontSize:'12px'}}>{project_name}</span>
		  </div>
		)
	}
}

//tag::create_button[]
class CreateButton extends React.Component{
	constructor(props) {
		super(props);
		this.app = props.app;
		this.handleCreateExecute = this.handleCreateExecute.bind(this);
		
		this.link = '';
	}
	
	handleCreateExecute() {
		var lParams = {};
		var lResult = []
		lParams.user = this.props.app.state.userSSO;
		lParams.project = this.props.projectGUID;

		client({method: 'GET', path: sessionData, params: lParams}).done(sessionInformation => {
			var lSessionInfo = encodeURIComponent(sessionInformation.entity.sessionInfo);
			window.open(this.link+"&usrSmgr="+lSessionInfo,"_self")
		});
	}
	
	render() {
		
		var create_type = this.props.create_type
		var serverURL = (this.props.app)?this.props.app.state.serverData.webserver:""
		var iServer = (this.props.app)?this.props.app.state.serverData.server:""
		var iProject = encodeURIComponent(this.props.project)
			
		if(create_type=='dashboard'){
			this.link = serverURL+"?evt=3187&src=Main.aspx.3187&project=" + iProject
		}
		else{
			this.link = serverURL+"?reportDesignMode=1&reportID=05B202B9999F4C1AB960DA6208CADF3D&promptsExecuteStyle=PromptsTransformClassicSave&promptsCreateStyle=PromptsTransformCreateReportSave&evt=3005&src=mstrWeb.3005&reportViewMode=1&promptStyle=PromptsTransformCreateReport&project=" + iProject
		}
		var project = this.props.project
		
		var btn_style = {
				  marginTop: '10px'
			};
		return (
			<div style={{textAlign:'center'}}>
				{
					(create_type != null && project != null) ? <RaisedButton backgroundColor={colorAccent}  labelColor='white' label='Create' style={btn_style} onClick={this.handleCreateExecute} /> : <RaisedButton label='Create' style={btn_style} disabled={true} />
				}
		    </div>
		)
	}
}
// end::create_button[]

//tag::PortalSearchBlock[]
class PortalSearchBlock extends React.Component{
	
	constructor(props) {
		super(props);
		this.state = {curtain: false};
	}
	
	render() {
		
		return (
			<div className="portalsearchblockprogress">
			  <div className="center-wrapper">
		  	  {
			  		(this.state.curtain==true)?
			  				<CircularProgress className="center-content"/>
			  				:<div />
			  }
		  	  </div>
		  	  {this.props.children}
			</div>
		)
	}
}
// end::PortalSearchBlock[]


//tag::PortalBlock[]
class PortalBlock extends React.Component{
	
	constructor(props) {
		super(props);
		this.state = {curtain: false};
	}
	
	
	render() {
		var title = this.props.title
		var image_source = "./img/" + this.props.image_name
		var back_image_source = "url(./img/" + this.props.back_image_name+")"
		var alt_text = "Recent Reports"
		var table_style = {border: '0px'}
		var last_updated = this.props.last_updated
		var text_align = (this.props.text_align || 'left')
		
		
		if(this.props.back_image_name){
			backgroundStyleEmbedded.backgroundImage=back_image_source;
			backgroundStyleEmbedded.height= parseInt(window.innerWidth/8.5) + "px";
		}

		return (

			<div className={this.props.isTableau?"portalblocktableauprogress":"portalblockprogress"} style={this.props.back_image_name?backgroundStyleEmbedded:{minHeight: '45px'}} >
			  <div className="center-wrapper">
		  	  {
			  		(this.state.curtain==true)?
			  				<CircularProgress className="center-content"/>
			  				:<div />
			  }
			  </div>
			  {
				  
			  }
			  {this.props.displayHeader &&	
				  <table className="PortalBlock">
			  	    <tbody>
			  	  	  <tr>
			  	  		  <td style={{width: '30px'}}><img src={image_source} alt={alt_text} height="30px" /></td>
			  	  		  <td style={{textAlign: 'left'}}>{title}</td>
			  	  		  <td style={{textAlign: 'right'}}>
				  	  		{last_updated && this._reactInternalInstance._currentElement._owner._instance.state.staticContents.filter(({type}) => type === 'Videos').map( (row, index) => {
		        				return (
		        						<em key={row.type}>Last Updated: {row.update_date}</em>
			                      )                	
			                },this)}	  		  
			  	  		  </td>
			  	  	  </tr>
			  	  	</tbody>
			  	  </table>
			  }
			  {this.props.displayHeader &&	
				  <hr  style={styleHRGreen} />
			  }
			  <div style={{textAlign: text_align}}>{this.props.children}</div>
		  	</div>
		)
	}
}
// end::PortalBlock[]

const folderItems = [
	   	{
	   		title: 'MicroStrategy',
	   	    depth: 0,
	   	    children: []
	   	}
   	]

const retrievedItems = [
	   	{
	   		title: 'MicroStrategy',
	   	    depth: 0,
	   	    childrenNode: [],
	   	    children: [],
		    objectGUID: 0,
		    objectType: 0,
		    objectProjectGUID: 0,
	   	}                
	]

class LeftNavBar extends React.Component {
	
	constructor(props) {
		super(props);
		var epochDate = new Date(0);
		this.handleTouchTap = this.handleTouchTap.bind(this);
		this.mTree = {};
		this.container = props.container;
		this.triggerInitialLoad = this.triggerInitialLoad.bind(this);
		this.state = {folders: [], pageSize: 0, projectsCurtain: false};
	}
	
	flatten(list) {
		const result = [];
		
		const addItem = (item, parentIndex, depth = 0) => {
			item.depth = depth;
		    if (parentIndex !== undefined) {
		      item.parentIndex = parentIndex;
		    }
	
		    const index = result.length;
		    result.push(item);
	
		    if (item.childrenNode.length > 0) {
		    	item.children = item.childrenNode.map(c => addItem(c, index, depth + 1));
		    }
	
		    return index;
		}
	
		// Add top-level items
		list.forEach(item => addItem(item));	
		return result;
	}
	
	triggerInitialLoad() {
		this.loadFromServer(retrievedItems[0]); 
	}
	
	// tag::follow-2[]
	loadFromServer(parentNode) {
		var lParams = {};
		lParams.user = this.container.state.userSSO;
		if(parentNode.objectGUID != 0){
			lParams.pid = parentNode.objectProjectGUID;
			lParams.oid = parentNode.objectGUID;
		}else{
			parentNode.childrenNode.push({
			   		title: 'Embedded Examples',
			   	    depth: 1,
			   	    childrenNode: [{
			   	    	title: 'Embedded Report',
						depth: 0,
						childrenNode: [],
						objectGUID: 0,
						objectType: "-11",
						objectProjectGUID: 0,
			   	    },{
			   	    	title: 'Tableau Embedded',
						depth: 0,
						childrenNode: [],
						objectGUID: 0,
						objectType: "-12",
						objectProjectGUID: 0,
			   	    }],
			   	    children: [],
				    objectGUID: 0,
				    objectType: "-10",
				    objectProjectGUID: 0,
				}
			)
		}
		client({method: 'GET', path: folderInfo, params: lParams}).done(folderCollection => {
			for (var prop in folderCollection.entity) {
			    if (folderCollection.entity.hasOwnProperty(prop)) {
			    	parentNode.childrenNode.push(
		        		{
		        			title: folderCollection.entity[prop].Name,
		        		    depth: parentNode.depth + 1,
		        		    objectGUID: folderCollection.entity[prop].GUID,
		        		    objectType: folderCollection.entity[prop].ObjectType,
		        		    objectSubType: folderCollection.entity[prop].ObjectSubType,
		        		    objectMode: folderCollection.entity[prop].ObjectView,
		        		    objectProjectGUID: parentNode.objectProjectGUID==0?folderCollection.entity[prop].GUID:parentNode.objectProjectGUID,
		        		    objectProjectName: parentNode.objectProjectGUID==0?folderCollection.entity[prop].Name:parentNode.objectProjectName,
		        		    childrenNode: [],
		        		    class: 'test'
		        		} 	
			        )
			        if(folderCollection.entity[prop].ObjectType != 3 && folderCollection.entity[prop].ObjectType != 55 
			        		&& folderCollection.entity[prop].ObjectType != -1 && folderCollection.entity[prop].ObjectType != -2) {
			        	parentNode.childrenNode[parentNode.childrenNode.length-1].children = [];
			        }
			    }
			}
			var lResultList;
			lResultList = this.flatten(retrievedItems);
			this.setState({
				folders: lResultList,
				projectsCurtain: false
			});
			if(this.container.navBlock.setState){
				this.container.navBlock.setState({
					curtain: false
				});
			}
		});
		if(this.container.navBlock.setState){
			this.container.navBlock.setState({
				curtain: true
			});
		}
	}
	
	componentDidMount() {
		
	}
	
	componentDidUpdate() {
		var lCrape = '';
	}
	
	handleTouchTap(source) {	
		var lTest = 0;
		var lServerURL = this.container.state.serverData.webserver;
		var lIServerName = this.container.state.serverData.server;
		var lProjectName = encodeURIComponent(source.objectProjectName);
		
		
		var lParams = {};
		var lResult = []
		lParams.user = this.container.state.userSSO;
		lParams.project = source.objectProjectGUID;
		
		client({method: 'GET', path: sessionData, params: lParams}).done(sessionInformation => {
			var lSessionInfo = encodeURIComponent(sessionInformation.entity.sessionInfo);
			switch(source.objectType){
				case '-1':
					window.open(lServerURL+"?server="+lIServerName+"&project="+lProjectName+"&evt=3031&src=Main.aspx.3031&usrSmgr="+lSessionInfo,"_self")
					break
				case '-2':
					window.open(lServerURL+"?server="+lIServerName+"&project="+lProjectName+"&evt=3018&src=Main.aspx.3018&usrSmgr="+lSessionInfo,"_self")
					break
				case '3':
					window.open(lServerURL+"?server="+lIServerName+"&project="+lProjectName+"&evt=4001&Main.aspx.4001&reportViewMode=1&reportID="+source.objectGUID+"&usrSmgr="+lSessionInfo,"_self")
					break
				case '55':
					if(source.objectMode == '8192') {
						window.open(lServerURL+"?evt=3140&Main.aspx.3140&documentID="+source.objectGUID+"&server="+lIServerName+"&project="+lProjectName+"&usrSmgr="+lSessionInfo,"_self")
					} else{
						window.open(lServerURL+"?server="+lIServerName+"&project="+lProjectName+"&evt=2048001&Main.aspx.2048001&currentViewMedia=2&documentID="+source.objectGUID+"&usrSmgr="+lSessionInfo,"_self")
					}
					break
				case '-10':
					break;
				case '-11':
					this.container.changeFullState("MstrEmbedded", false);
					break;
				case '-12':
					this.container.changeFullState("TableauEmbedded", false);
					break;
				default:
					if(source.children.length == 0){
						this.loadFromServer(source);
					}
			}
		});
	}
	
	render() {
		const icons = {
				leftIconCollapsed: <i style={{height: 16, width: 16, color: '#CCCCCC'}} className="fa fa-caret-right" />,
				leftIconExpanded: <i style={{height: 16, width: 16, color: '#CCCCCC'}} className="fa fa-caret-down" />
			}
		
		return (
			<div className="treelistdiv">
				<TreeList
	                ref={(c) => this.mTree = c}
					listItems={this.state.folders}
					contentKey={'title'}
					handleTouchTap={this.handleTouchTap}
					useFolderIcons={false}
					icons={icons}
				/>
			</div>
		)
	}
}

ReactDOM.render(
		(<Router>
			<Route path="/" component={App} />
	    	<Route path="/Login" component={LoginForm} />
	    </Router>), document.getElementById('react')
)

// tag::render[]
//ReactDOM.render(
//	<div>
//	  {/* https://stackoverflow.com/questions/14007655/remove-ie10s-clear-field-x-button-on-certain-inputs */}
//	  <style type='text/css' dangerouslySetInnerHTML={{__html: '::-ms-clear {display: none;}'}} />
//	  <App />
//	</div>,
//	document.getElementById('react')
//)
// end::render[]




// WEBPACK FOOTER //
// ./src/main/js/app.js